import httpClient from "./httpClient";

export const cityApi = {
    list: async () => {
        return httpClient.get("city");
    }
}